import React, { useState, useEffect, Fragment } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { setAlert } from '../../../actions/alert';
import {
    limpiarProductoConfiguracion,
    obtenerProductoConfiguracion,
    editarProductoConfiguracion,
    buscarCategoriasConfiguracion,
    buscarSubcategoriasConfiguracion,
    buscarUnidades
} from '../../../actions/configuracion';

import { CustomValueContainer } from '../../../components/react_select/ReactSelect';

const EditarProducto = ({ producto, reestablecerProducto }) => {

    const dispatch = useDispatch();

    const { detalles } = useSelector(state => state.configuracion.productos);
    const { listado: listado_unidades } = useSelector(state => state.configuracion.unidades);
    const { listado: listado_categorias } = useSelector(state => state.configuracion.categorias);
    const { listado: listado_subcategorias } = useSelector(state => state.configuracion.subcategorias);

    const [editarModal, setEditarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const [productoData, setProductoData] = useState({
        id: null,
        id_categoria: null,
        id_subcategoria: null,
        id_subsubcategoria: null,
        nombre: '',
        fabricante: '',
        reorden: '',
        codigo: '',
        clave_alternativa: '',
        precio_compra: '',
        precio_venta: '',
        descripcion: '',
        unidades: []
    });

    const [categoriaData, setCategoriaData] = useState(null);
    const [categoriasFilter, setCategoriasFilter] = useState([]);

    const [subcategoriaData, setSubcategoriaData] = useState(null);
    const [subcategoriasFilter, setSubcategoriasFilter] = useState([]);

    const [tiposData, setTiposData] = useState([]);
    const tiposFilter = [
        { value: 1, label: 'Inventario' },
        { value: 3, label: 'Venta' }
    ];

    const [unidadesData, setUnidadesData] = useState([]);
    const [unidadesFilter, setUnidadesFilter] = useState([]);
    const [initializedFromDetalles, setInitializedFromDetalles] = useState(false);

    let styles_select = {
        menuPortal: base => ({ ...base, zIndex: 9999 }),
        container: (provided) => ({ ...provided }),
        valueContainer: (provided) => ({
            ...provided,
            overflow: "visible",
            marginTop: "10px"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            position: "absolute",
            top: state.hasValue || state.selectProps.inputValue ? -15 : "0%",
            transition: "top 0.1s, font-size 0.1s",
            fontSize: (state.hasValue || state.selectProps.inputValue) && 13
        })
    };

    const handleAbrir = () => {
        dispatch(limpiarProductoConfiguracion());
        dispatch(buscarCategoriasConfiguracion());
        dispatch(buscarUnidades());

        const categoriaIdFromRow =
            producto?.id_categoria ??
            producto?.categoria?._id ??
            null;

        if (categoriaIdFromRow) {
            dispatch(buscarSubcategoriasConfiguracion(categoriaIdFromRow));
        }
    };

    const handleInputChange = ({ target }) => {
        setProductoData(prev => ({
            ...prev,
            [target.name]: target.value
        }));
    };

    const handleSelectCategoria = (option) => {
        const id_categoria = option ? option.value : null;

        setProductoData(prev => ({
            ...prev,
            id_categoria,
            id_subcategoria: null
        }));

        setCategoriaData(option);
        setSubcategoriaData(null);

        if (id_categoria) {
            dispatch(buscarSubcategoriasConfiguracion(id_categoria));
        } else {
            setSubcategoriasFilter([]);
        }
    };

    const handleSelectSubcategoria = (option) => {
        const id_subcategoria = option ? option.value : null;

        setProductoData(prev => ({
            ...prev,
            id_subcategoria,
            id_subsubcategoria: null
        }));

        setSubcategoriaData(option);
    };

    const handleAgregarUnidad = () => {
        const unidades = Array.isArray(productoData.unidades) ? [...productoData.unidades] : [];

        unidades.push({
            id: '',
            id_unidad: '',
            tipo: '',
            cantidad: '',
            eliminado: 0
        });

        setProductoData(prev => ({
            ...prev,
            unidades
        }));

        setUnidadesData(prev => ([...prev, null]));
        setTiposData(prev => ([...prev, null]));
    };

    const handleCantidadChange = ({ target }) => {
        const nombre_separado = (target.name || '').split('cantidad_');
        const posicion = Number(nombre_separado[1]);

        if (Number.isNaN(posicion)) return;

        const unidades = Array.isArray(productoData.unidades) ? [...productoData.unidades] : [];
        if (!unidades[posicion]) return;

        unidades[posicion] = {
            ...unidades[posicion],
            cantidad: target.value || ''
        };

        setProductoData(prev => ({
            ...prev,
            unidades
        }));
    };

    const handleSelectTipo = (option, position) => {
        const unidades = Array.isArray(productoData.unidades) ? [...productoData.unidades] : [];
        if (!unidades[position]) return;

        unidades[position] = {
            ...unidades[position],
            tipo: option ? option.value : ''
        };

        const tipos = [...tiposData];
        tipos[position] = option || null;

        setTiposData(tipos);

        setProductoData(prev => ({
            ...prev,
            unidades
        }));
    };

    const handleSelectUnidad = (option, position) => {
        const unidades = Array.isArray(productoData.unidades) ? [...productoData.unidades] : [];
        if (!unidades[position]) return;

        unidades[position] = {
            ...unidades[position],
            id_unidad: option ? option.value : ''
        };

        const ids_unidades = [...unidadesData];
        ids_unidades[position] = option || null;

        setUnidadesData(ids_unidades);

        setProductoData(prev => ({
            ...prev,
            unidades
        }));
    };

    const handleEliminarUnidad = ({ currentTarget }) => {
        const id_separado = (currentTarget.id || '').split('_');
        const index = Number(id_separado[1]);

        if (Number.isNaN(index)) return;

        const unidades = Array.isArray(productoData.unidades) ? [...productoData.unidades] : [];
        if (!unidades[index]) return;

        const tipos = [...tiposData];
        const ids_unidades = [...unidadesData];

        const tieneId = unidades[index]?.id && String(unidades[index].id).trim() !== '';

        if (!tieneId) {
            unidades.splice(index, 1);
            tipos.splice(index, 1);
            ids_unidades.splice(index, 1);
        } else {
            unidades[index] = {
                ...unidades[index],
                eliminado: 1
            };
            tipos[index] = null;
            ids_unidades[index] = null;
        }

        setProductoData(prev => ({
            ...prev,
            unidades
        }));

        setTiposData(tipos);
        setUnidadesData(ids_unidades);
    };

    const handleFilasUnidades = (unidades) => {
        const unidades_campos = [];

        if (Array.isArray(unidades)) {
            for (let x = 0; x < unidades.length; x++) {
                if ((unidades[x]?.eliminado ?? 0) === 0) {
                    unidades_campos.push(
                        <div className="col-md-12 form-group mb-3" key={`unidad-${x}`}>
                            <div className="input-group h-100">
                                <div className="form-floating h-100">
                                    <Select
                                        name="tipo"
                                        className="select-group"
                                        classNamePrefix="react-select"
                                        placeholder={'Tipo de unidad ' + (x + 1)}
                                        options={tiposFilter}
                                        value={tiposData[x] || null}
                                        isClearable={true}
                                        onChange={(value) => handleSelectTipo(value, x)}
                                        menuPortalTarget={document.body}
                                        menuPlacement="auto"
                                        components={{ ValueContainer: CustomValueContainer }}
                                        styles={{ ...styles_select }}
                                    />
                                </div>

                                <div className="form-floating h-100">
                                    <Select
                                        name="unidad"
                                        className="select-group"
                                        classNamePrefix="react-select"
                                        placeholder={'Unidad ' + (x + 1)}
                                        options={unidadesFilter}
                                        value={unidadesData[x] || null}
                                        isClearable={true}
                                        onChange={(value) => handleSelectUnidad(value, x)}
                                        menuPortalTarget={document.body}
                                        menuPlacement="auto"
                                        components={{ ValueContainer: CustomValueContainer }}
                                        styles={{ ...styles_select }}
                                    />
                                </div>

                                <div className="form-floating">
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Cantidad"
                                        id={'cantidad_' + x}
                                        name={'cantidad_' + x}
                                        value={unidades[x].cantidad || ''}
                                        onChange={handleCantidadChange}
                                    />
                                    <label htmlFor={'cantidad_' + x}>Cantidad {x + 1}</label>
                                </div>

                                <div className="input-group-append">
                                    <button
                                        type="button"
                                        className="btn btn-danger delete"
                                        id={'eliminarUnidad_' + x}
                                        onClick={handleEliminarUnidad}
                                    >
                                        <i className="fa-solid fa-xmark"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                }
            }
        }

        return unidades_campos;
    };

    const handleProcesar = async () => {
        const nombreValido = productoData.nombre && productoData.nombre.trim() !== '';
        const codigoValido = productoData.codigo && productoData.codigo.trim() !== '';

        if (!nombreValido || !codigoValido) {
            await dispatch(setAlert('El nombre y el código son requeridos', 'danger'));
            return;
        }

        const unidadesLimpias = Array.isArray(productoData.unidades)
            ? productoData.unidades
                .filter(u => (u?.eliminado ?? 0) === 0)
                .map(u => ({
                    id: u.id || '',
                    id_unidad: u.id_unidad || '',
                    tipo: u.tipo !== undefined && u.tipo !== null ? u.tipo : '',
                    cantidad: u.cantidad !== undefined && u.cantidad !== null ? u.cantidad : ''
                }))
            : [];

        setStatusProcesar(true);
        await dispatch(editarProductoConfiguracion({
            ...productoData,
            unidades: unidadesLimpias
        }));
        handleCerrar();
        setStatusProcesar(false);
    };

    const handleCerrar = () => {
        if (statusProcesar) return;

        dispatch(limpiarProductoConfiguracion());

        setProductoData({
            id: null,
            id_categoria: null,
            id_subcategoria: null,
            nombre: '',
            fabricante: '',
            reorden: '',
            codigo: '',
            clave_alternativa: '',
            precio_compra: '',
            precio_venta: '',
            descripcion: '',
            unidades: []
        });

        setTiposData([]);
        setUnidadesData([]);

        setCategoriaData(null);
        setSubcategoriaData(null);

        setInitializedFromDetalles(false);
        setEditarModal(false);
        reestablecerProducto(null);
    };

    useEffect(() => {
        if (!producto) return;

        setEditarModal(true);

        dispatch(limpiarProductoConfiguracion());

        dispatch(buscarCategoriasConfiguracion());
        dispatch(buscarUnidades());

        const categoriaIdFromRow =
            producto?.id_categoria ??
            producto?.categoria?._id ??
            null;

        if (categoriaIdFromRow) {
            dispatch(buscarSubcategoriasConfiguracion(categoriaIdFromRow));
        }

        dispatch(obtenerProductoConfiguracion(producto?._id));
    }, [producto, dispatch]);

    useEffect(() => {
        const options = [];
        for (let i = 0; i < (listado_unidades || []).length; i++) {
            options.push({
                value: listado_unidades[i]._id ?? listado_unidades[i].id,
                label: listado_unidades[i].nombre
            });
        }
        setUnidadesFilter(options);
    }, [listado_unidades]);

    useEffect(() => {
        const options = [];
        for (let i = 0; i < (listado_categorias || []).length; i++) {
            options.push({
                value: listado_categorias[i]._id ?? listado_categorias[i].id,
                label: listado_categorias[i].nombre
            });
        }
        setCategoriasFilter(options);
    }, [listado_categorias]);

    useEffect(() => {
        const options = [];
        for (let i = 0; i < (listado_subcategorias || []).length; i++) {
            options.push({
                value: listado_subcategorias[i]._id ?? listado_subcategorias[i].id,
                label: listado_subcategorias[i].nombre
            });
        }
        setSubcategoriasFilter(options);
    }, [listado_subcategorias]);

    useEffect(() => {
        if (detalles) {
            const categoriaId =
                detalles.id_categoria ??
                detalles.categoria?._id ??
                null;

            if (categoriaId) {
                dispatch(buscarSubcategoriasConfiguracion(categoriaId));
            }
        }
    }, [detalles, dispatch]);

    useEffect(() => {
        if (!detalles || initializedFromDetalles) return;

        const categoriaId =
            detalles.id_categoria ??
            detalles.categoria?._id ??
            null;

        const subcategoriaId =
            detalles.id_subcategoria ??
            detalles.subcategoria?._id ??
            null;

        const unidadesDetalle = Array.isArray(detalles.unidades)
            ? detalles.unidades.map(u => ({
                id: u._id ?? u.id ?? '',
                id_unidad: u.id_unidad ?? u.unidad?._id ?? '',
                tipo: u.tipo ?? '',
                cantidad: u.cantidad ?? '',
                eliminado: u.eliminado ?? 0
            }))
            : [];

        if (unidadesDetalle.length > 0 && unidadesFilter.length === 0) return;

        setProductoData(prev => ({
            ...prev,
            id: detalles.id ?? detalles._id,
            id_categoria: categoriaId,
            id_subcategoria: subcategoriaId,
            nombre: detalles.nombre ?? '',
            fabricante: detalles.fabricante ?? '',
            reorden: detalles.reorden ?? '',
            codigo: detalles.codigo ?? '',
            clave_alternativa: detalles.clave_alternativa ?? '',
            precio_compra: detalles.precio_compra ?? '',
            precio_venta: detalles.precio_venta ?? '',
            descripcion: detalles.descripcion ?? '',
            unidades: unidadesDetalle
        }));

        if (categoriaId) {
            setCategoriaData({
                value: categoriaId,
                label: detalles.categoria?.nombre ?? ''
            });
        } else {
            setCategoriaData(null);
        }

        if (subcategoriaId) {
            setSubcategoriaData({
                value: subcategoriaId,
                label: detalles.subcategoria?.nombre ?? ''
            });
        } else {
            setSubcategoriaData(null);
        }

        const ids_unidades = [];
        const tipos = [];

        for (let i = 0; i < unidadesDetalle.length; i++) {
            const currentUnidad = unidadesDetalle[i];

            const unidadOption = unidadesFilter.find(
                u => String(u.value) === String(currentUnidad.id_unidad)
            );
            ids_unidades.push(unidadOption || null);

            const tipoOption = tiposFilter.find(
                t => String(t.value) === String(currentUnidad.tipo)
            );
            tipos.push(tipoOption || null);
        }

        setUnidadesData(ids_unidades);
        setTiposData(tipos);

        setInitializedFromDetalles(true);
    }, [detalles, unidadesFilter, initializedFromDetalles]);

    return (
        <Fragment>
            <HelmetProvider>
                <Helmet>
                    <style>{`
                        .selectIconos, .select-group {
                            height: 100%;
                        }

                        .delete {
                            padding: 0.39rem 0.70rem !important;
                            border-radius: 0 25% 25% 0 !important;
                            height: 100%;
                        }

                        .btn-morado {
                            background: #6f42c1 !important;
                            border-color: #6f42c1 !important;
                            color: #fff !important;
                        }

                        .btn-morado:hover {
                            filter: brightness(0.95);
                        }
                    `}</style>
                </Helmet>
            </HelmetProvider>

            <Modal
                show={editarModal}
                size="xl"
                backdrop="static"
                centered
                onHide={handleCerrar}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Editar producto</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="row">
                        <div className="col-md-3 form-group mb-2">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Código"
                                        id="codigo"
                                        name="codigo"
                                        value={productoData.codigo}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="codigo">Código</label>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-9 form-group mb-2">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Nombre"
                                        id="nombre"
                                        name="nombre"
                                        value={productoData.nombre}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="nombre">Nombre</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6 form-group mb-2">
                            <div className="input-group h-100">
                                <Select
                                    name="id_categoria"
                                    className="select-group"
                                    classNamePrefix="react-select"
                                    placeholder="Categoría"
                                    options={categoriasFilter}
                                    value={categoriaData}
                                    isClearable={true}
                                    onChange={handleSelectCategoria}
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    components={{ ValueContainer: CustomValueContainer }}
                                    styles={{ ...styles_select }}
                                />
                            </div>
                        </div>

                        <div className="col-md-6 form-group mb-2">
                            <div className="input-group h-100">
                                <Select
                                    name="id_subcategoria"
                                    className="select-group"
                                    classNamePrefix="react-select"
                                    placeholder="Subcategoría"
                                    options={subcategoriasFilter}
                                    value={subcategoriaData}
                                    isClearable={true}
                                    onChange={handleSelectSubcategoria}
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    components={{ ValueContainer: CustomValueContainer }}
                                    styles={{ ...styles_select }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 form-group mb-2">
                            <div className="input-group">
                                <div className="form-floating">
                                    <textarea
                                        className="form-control textareCampo"
                                        placeholder="Descripción"
                                        id="descripcion"
                                        name="descripcion"
                                        value={productoData.descripcion}
                                        onChange={handleInputChange}
                                    ></textarea>
                                    <label htmlFor="descripcion">Descripción</label>
                                </div>
                            </div>
                        </div>

                        {handleFilasUnidades(productoData.unidades)}
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    {statusProcesar ? (
                        <>
                            <button type="button" className="btn btn-morado" disabled>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Unidad
                            </button>
                            <button type="button" className="btn btn-success" disabled>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Guardar
                            </button>
                        </>
                    ) : (
                        <>
                            <button type="button" className="btn btn-morado" onClick={handleAgregarUnidad}>
                                <i className="fas fa-plus fa-sm"></i> Unidad
                            </button>
                            <button type="button" className="btn btn-success" onClick={handleProcesar}>
                                <i className="fas fa-check fa-sm"></i> Guardar
                            </button>
                        </>
                    )}
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default EditarProducto;
